// Copyright (c) StrangeBee 2023

import { CatalogInput, CatalogPatternController } from 'thehive-sdk';

export interface CatalogEventList {
    onCreate: (values: CatalogInput) => void;
    onEdit: (catalog: Partial<CatalogInput>, catalogId: string) => void;
    onDelete: (catalogId: string) => void;
}

interface EventListParams {
    locale: (label: string) => string;
    controller: CatalogPatternController;
    onSuccess: (count?: boolean, message?: string) => void;
    onError: (label?: string) => void;
}

export const computeEventList = ({ controller, locale, onError, onSuccess }: EventListParams): CatalogEventList => ({
    onDelete: (catalogId): void => {
        controller
            .delete(catalogId)
            .then(() => {
                onSuccess(false, locale('notification.catalog.delete'));
            })
            .catch(onError);
    },
    onCreate: (values: CatalogInput): void => {
        controller
            .create(values)
            .then(() => {
                onSuccess(false, locale('notification.catalog.create'));
            })
            .catch(onError);
    },
    onEdit: (data: Partial<CatalogInput>, catalogId: string): void => {
        controller
            .edit<Partial<CatalogInput>, void>(data, catalogId)
            .then(() => onSuccess(false, locale('notification.catalog.edit')))
            .catch(onError);
    },
});
